import React from 'react';

export default function TermsAndConditions() {
    return (
        <div style={{ width: '100%', height: '100vh', margin: 0, overflow: 'hidden' }}>
            <iframe
                src="https://app.puresocialcx.com/terms-of-services/"
                style={{
                    width: '100%',
                    height: '100%',
                    border: 'none',
                    display: 'block',
                    overflowY: 'auto' // Habilita el scroll si es necesario
                }}
                title="Terms and Conditions"
            >
                Cargando...
            </iframe>
        </div>
    );
}